'use client';

import { FC } from 'react';

import { Text } from '@virginmediao2/momentum-nextjs/text';

import Flex from '@/components/momentum/components/flex-box';
import { Section } from '@/components/momentum/components/section';
import { ThemeSwitcher } from '@/components/momentum/theme/theme-switcher';

import styles from './error.module.css';

interface AppErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

const AppError: FC<AppErrorProps> = () => (
  <ThemeSwitcher theme='o2_rebrand' className={styles['page']}>
    <Section layout='cozy' variant={'secondary'}>
      <Flex
        flexDirection='column'
        justifyContent='center'
        alignItems='center'
        gap={32}
      >
        <Text as='h2' size='T900' weight='heavy'>
          Uh oh...
        </Text>
        <Text as='p' size='T500'>
          Oops.. something’s gone wrong.
        </Text>
      </Flex>
    </Section>
  </ThemeSwitcher>
);

export default AppError;
